export default {
    dashboard: 'Dashboard',
    inquiryAttendance: 'Inquiry & Attendance',
    employeeManagement: 'Employee Management',
    pin: 'PIN',
    messageManagement: 'Message Management',
    timableSettings: 'Timetable Setting',
    report: 'Report',
    visitor: 'Visitor',
    logOut: 'Log Out',
    powerdBy: 'Powered by OKONTEK'
}
